/* API request complete path */
let BASE_URL;

if (typeof window !== 'undefined') {
  if (window.location.host === "operations-admin.pluc.tv") {
    BASE_URL = process.env.REACT_APP_HOST;
  } else {
    BASE_URL = process.env.REACT_APP_HOST_STAGING;
  }
} else {
  BASE_URL = process.env._STAGING;
}

export const API_URL = BASE_URL + "/";

/* Key for API authentication */
export const API_HEADER_AUTH_KEY = process.env.REACT_APP_API_HEADER_AUTH_KEY;

/** API status */
export const STATUS_SUCCESS 	= 200;
export const STATUS_ERROR 		= "error";


export const AM_PM_FORMAT_WITH_DATE			=	"YYYY/MM/DD hh:mm A";
export const ORDER_FORMAT_WITH_DATE			=	"DD MMMM YYYY";
export const DATABASE_DATE_FORMAT 	    = "DD-MM-YYYY";

/** Contract status options */ 
export const STATUS_PENDING 	      = "pending";
export const STATUS_COMPLETED 	    = "completed";
export const STATUS_CHANGE_REQUEST 	= "changes_requested";
export const STATUS_SENT 	          = "sent";


/* Contract status dropdown */

export const CONTRACT_STATUS		        =	{};
CONTRACT_STATUS[STATUS_PENDING]	        =	{status_type: STATUS_PENDING, status_name: "Pending", label_class: "badge bg-danger"};
CONTRACT_STATUS[STATUS_COMPLETED]	      =	{status_type: STATUS_COMPLETED, status_name: "Completed", label_class: "badge bg-success"};
CONTRACT_STATUS[STATUS_CHANGE_REQUEST]	=	{status_type: STATUS_CHANGE_REQUEST, status_name: "Changes Requested", label_class: "badge bg-warning"};
CONTRACT_STATUS[STATUS_SENT]	          =	{status_type: STATUS_SENT, status_name: "Sent", label_class: "badge bg-secondary"};

/** Contract with */
export const PLUC_PRIVATE_NETWORK 	 = "pluc_network_private_limited";
export const PLUC_GLOBAL_NETWORK	   = "pluc_global_private_limited";


export const CONTRACT_WITH    =	[
  {value : "" , label : "Select Contract With"},
  {value : "Pluc Network Private Limited" , label : "Pluc Network Private Limited"},
  {value : "Pluc Global Pvt Ltd" , label : "Pluc Global Pvt Ltd"}
];

